import Vue from 'vue'
import App from './App.vue'
import routes from './router/index'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import $ from 'jquery'
import { BootstrapVue, BootstrapVueIcons  } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import { auth } from '@/firebase';
import { validateAsset } from "./plugins/validAsset"
import VueRouter from "vue-router";    
import VueGtag from 'vue-gtag';
Vue.use(VueRouter);
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueAxios, axios);

window.axios = require('axios')
window.$ = require('jquery')

Vue.config.productionTip = false;

const router = new VueRouter({

    linkActiveClass: 'active',
    mode: 'history',
    routes
});
Vue.use(VueGtag, {
	config: {
			id: 'GTM-MNFJHPWF',
			params: {
					send_page_view: false
			}
	}
}, router)



router.beforeEach((to, from, next) => {
    // Configurar el título de la página
    const defaultTitle = 'Mission Magazine';
    document.title = to.meta?.title ? `${to.meta.title} • ${defaultTitle}` : defaultTitle;
     
    // Obtener el estado de autenticación del usuario
    const isUserLogged = localStorage.getItem('logged');
    const token = localStorage.getItem('token');
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const requiresAssetAccess = to.matched.some(record => record.meta.asset);
    const user = store.state.user;

    // Verificar autenticación
    if (requiresAuth && (!user || !isUserLogged || !token )) {
      return next('/the-magazine');
    }
  
    // Verificar acceso a los recursos
    if (requiresAuth && requiresAssetAccess) {
      const requiredAssets = to.meta.asset || [];
      const userAssets = store.state.issue;
  
      if (validateAsset(userAssets, requiredAssets)) {
        return next();
      } else {
        return next('/home');
      }
    }
  
    next();
  });



/* router.beforeEach((to, from, next) => {
    window.document.title = to.meta && to.meta.title ? to.meta.title + ' • Mission Magazine' : 'Mission Magazine';
    let user_logged = localStorage.getItem('logged')
    let token = localStorage.getItem('token')
    let auth = to.matched.some(record => record.meta.requiresAuth)
    let asset = to.matched.some(record => record.meta.asset)

    if (auth) {
        if (!user_logged && !token) {
            next('/the-magazine')
        } else {
            if (asset) {
                let accesAsset = []
                accesAsset = to.meta.asset
                let assets = store.state.issue
                let validate = validateAsset(assets, accesAsset)           
                if(validate ){
                    next()
                } else {
                    next('/home')
                }
            } else {
                next()
            }
        }
    } else {
        next()
    }

}); */
let app

auth.onAuthStateChanged((user) => {
    if (user) {
      store.commit('setUser', user); // Guardar el usuario en el estado global (Vuex)
    } else {
      store.commit('setUser', null); // No hay usuario autenticado
      localStorage.removeItem('token');
      localStorage.removeItem('logged');
    }
if (!app) {
    app = new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
}
/* 
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app') */
})